import React, {useEffect, useState} from 'react'
import {Button, Card, Table} from "antd";
import {getScrapsWithPage} from "../../services/serviceScrap";
import ScrapCreate from "./ScrapCreate";
import ScrapActions from "./ScrapActions";

const Scrap = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getScraps(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getScraps = (page, pageSize) => {
        getScrapsWithPage(page - 1, pageSize)
            .then(({data}) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
        })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getScraps(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    prodNo: item.production.productionNumber,
                    stock: `${item.stock.code} - ${item.stock.name}`,
                    quantity: item.quantity,
                    prodInfo: item.production,
                    stockInfo: item.stock,
                    note: item.note
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Üretim No',
            dataIndex: 'prodNo',
            key: 'prodNo'
        },
        {
            title: 'Stok',
            dataIndex: 'stock',
            key: 'stock'
        },
        {
            title: 'Adet',
            dataIndex: 'quantity',
            key: 'quantity'
        },
        {
            title: 'İşlemler',
            render: (t,r) => <ScrapActions record={r} updater={handlers.updater} />
        }
    ];

    return(
        <React.Fragment>
            <Card
                title={'Hurda Listesi'}
                extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}
            >
                <Table 
                columns={columns}
                 dataSource={sortedList} 
                 pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                }}
                 />
            </Card>

            {
                newModal ? <ScrapCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater}/> : null
            }

        </React.Fragment>
    )
}
export default Scrap